import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CssService } from 'src/app/services/css-service';

@Component({
  selector: 'app-options-dialog',
  templateUrl: './options-dialog.component.html',
  styleUrls: ['./options-dialog.component.css']
})
export class OptionsDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<OptionsDialogComponent>,
    public cssService: CssService,
  ) { }

  isClosing = false;
  selectedOption: string | null = null;
  showDivisionOptions = false;

  onSelect(option: string): void {
    this.selectedOption = option;
    this.isClosing = true;
  }

  onCancel() {
    this.selectedOption = null;
    this.isClosing = true;
  }

  onAnimationEnd() {
    if (this.isClosing)
      this.dialogRef.close(this.selectedOption);
  }
}
